import { useForm } from "@tanstack/react-form";
import { z } from "zod";

export const useGeneratedForm = (formConfig, onSubmit) => {
  const formSchema = z.object(
    Object.fromEntries(
      Object.entries(formConfig)
        .filter(([_, config]) => config.validation) // Ensure validation exists
        .map(([key, config]) => [key, config.validation])
    )
  );

  // Generate default values
  const defaultValues = Object.keys(formConfig).reduce((defaults, key) => {
    defaults[key] = formConfig[key].defaultValue;
    return defaults;
  }, {});

  // Use React Form Hook
  const form = useForm({
    defaultValues,
    validationSchema: formSchema,
    onSubmit,
    validators: { onChange: formSchema },
  });

  return form;
};
